import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";
import { getFilterDisplayText } from "@/utils/dateFilters";

interface UserTimeEntriesStateProps {
  isLoading: boolean;
  hasEntries: boolean;
  totalEntries?: number;
  filteredEntries?: number;
  selectedMonth?: string;
}

export function UserTimeEntriesState({
  isLoading,
  hasEntries,
  totalEntries,
  filteredEntries,
  selectedMonth,
}: UserTimeEntriesStateProps) {
  if (isLoading) {
    return (
      <div className="space-y-3 animate-in fade-in-0 duration-200">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    );
  }

  if (totalEntries && filteredEntries !== undefined && filteredEntries < totalEntries && selectedMonth) {
    return (
      <Alert className="mb-4">
        <InfoIcon className="h-4 w-4" />
        <AlertDescription>
          {filteredEntries} von {totalEntries} Einträge für {getFilterDisplayText(selectedMonth)} angezeigt.
          {filteredEntries === 0 && " Keine Einträge für diesen Zeitraum gefunden."}
        </AlertDescription>
      </Alert>
    );
  }

  if (!hasEntries) {
    return (
      <div className="text-center text-gray-500 py-8">
        <p>Keine Zeiteinträge für diesen Benutzer gefunden.</p>
      </div>
    );
  }

  return null;
}
